/**
 * Portal Entry Point for Workforce Notices Domain
 *
 * Registers the per-type viewer dispatcher block component with the
 * Crud component registry. Loaded via virtual:portal-entries when the
 * 'workforce-notices' package is registered with PackageRegistryService.
 *
 * Custom Components (SSOT):
 * - Workforce::UserNoticeDetailsBlock — type-aware viewer block, dispatches
 *   to per-UserNoticeType sub-components based on `item.type`.
 */

import { registerBlockComponent } from "@ja/crud/services/componentRegistry";

registerBlockComponent(
    "Workforce::UserNoticeDetailsBlock",
    () => import("./Components/UserNoticeDetails/UserNoticeDetailsBlock.vue"),
    "workforce-notices"
);
